import React, { useState } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

/**
 * The npm classic build does not include source-editing; this adds a raw HTML toggle.
 */
export default function CKEditorWithSource({
  data,
  onChange,
  config = {},
  heightClassName = "ckeditor-height-200",
  containerStyle,
  disabled = false
}) {
  const [showSource, setShowSource] = useState(false);

  return (
    <div className={heightClassName} style={containerStyle}>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          padding: "4px 6px 6px",
          background: "#f9fafb",
          borderBottom: "1px solid var(--gray-300)"
        }}
      >
        <button
          type="button"
          className="btn btn-outline btn-sm"
          onClick={() => setShowSource((v) => !v)}
          disabled={disabled}
        >
          {showSource ? "Rich text" : "View source"}
        </button>
      </div>
      {showSource ? (
        <textarea
          className="form-control ck-html-source"
          value={data == null ? "" : data}
          onChange={(e) => onChange(e.target.value)}
          disabled={disabled}
          placeholder="HTML source…"
          spellCheck={false}
          style={{ borderRadius: 0, border: "none" }}
        />
      ) : (
        <CKEditor
          editor={ClassicEditor}
          data={data}
          config={config}
          disabled={disabled}
          onChange={(_event, editor) => onChange(editor.getData())}
        />
      )}
    </div>
  );
}
